import { OnInit, Component, ViewChild } from '@angular/core';
import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IResult } from 'app/shared/models/result.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SnotifyService } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
import { IDtoNote } from 'app/shared/models/quote/note.model';
import { BudgetService } from '../budget.service';

@Component({
    selector: 'app-notes',
    styleUrls: ['./notes.style.scss'],
    templateUrl: 'notes.template.html'
})
export class NotesComponent implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formNote: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Variables */
    private now: number;
    SelectionType = SelectionType;
    /**Listas */
    private notes = new Array() as IDtoNote[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableNotes: DatatableComponent;
    public constructor(private configurationService: ConfigurationService
        , private spinner: NgxSpinnerService
        , private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private budgetService: BudgetService) {
        this.initializeFormNote();
        this.configToast = this.configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.now = Date.now();
        if (this.configurationService.isReady) {
            this.spinner.show();
            this.getNotes();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.spinner.show();
                this.getNotes();
            });
        }
    }
    private initializeFormNote() {
        this.formNote = this.formBuilder.group({
            name: [null, Validators.required],
            description: [null, Validators.required],
            isDefault: [null, Validators.required]
        });
    }
    private getNotes(): void {
        this.budgetService.getNotes()
            .subscribe(
                (x) => {
                    this.notes = x.data as IDtoNote[];
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private save(): void {
        if (!this.formNote.valid) {
            this.snotifyService.error('Ingrese los datos requeridos'
                , 'Error', this.configToast);
            return;
        }
        let data = this.formNote.value as IDtoNote;
        data.isActive = true;
        data.isVisible = true;
        this.budgetService.addNote(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.formNote.reset();
                        this.getNotes();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }

    private deleteNote(row: IDtoNote): void {
        this.budgetService.deleteNote(row.id)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getNotes();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
}
